module.exports = __webpack_public_path__ + "static/img/banner_11.d03189c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_11.jpg
// module id = ZTyL
// module chunks = 0